import { Group, Path } from "paper/dist/paper-core";
import { CANVAS_CENTER } from "../../constants";
import Beard from "./Beard";
import Ears from "./Ears";
import Eyes from "./Eyes";
import Glasses from "./Glasses";
import Hair from "./Hair";
import Nose from "./Nose";
import Shirt from "./Shirt";
import { delay } from "../utils/delay";

export default class Me extends Group {
  constructor() {
    const shirt = new Shirt();
    const glasses = new Glasses();
    const eyes = new Eyes();
    const ears = new Ears();
    const nose = new Nose();
    const beard = new Beard();
    const hair = new Hair();

    super([shirt, glasses, eyes, ears, nose, beard, hair]);

    this.eyes = eyes;
    this.glasses = glasses;
    this.hair = hair;
    this.initialPositionY = this.position.y;

    this.clipMe();
  }

  eyes: Eyes;
  glasses: Glasses;
  hair: Hair;
  initialPositionY: number;

  private clipMe() {
    const meClippingPath = new Path({
      segments: [
        [CANVAS_CENTER, 0],
        [15, 0],
        [15, 1],
        [15, CANVAS_CENTER + 6],
        [CANVAS_CENTER, 85],
        [100 - 15, CANVAS_CENTER + 6],
        [100 - 15, 1],
        [100 - 15, 0],
      ],
      closed: true,
      fillColor: "red",
      clipMask: true,
    });
    meClippingPath.smooth();

    new Group([this, meClippingPath]);

    this.position.y = this.initialPositionY + 15;
    this.opacity = 0;
  }

  moveUp() {
    return this.tweenTo(
      { "position.y": this.initialPositionY, opacity: 1 },
      { duration: 300, easing: "easeOutQuad" },
    );
  }

  async animateIn() {
    await Promise.all([
      this.moveUp(),
      this.glasses.animateIn(),
      this.hair.animateIn(),
    ]);

    await delay(2000);

    await this.eyes.blink();

    await delay(1000);

    await this.eyes.blink();
  }
}
